const COLUMBUS_DATE = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function isApplicationDeadlinePassed(closeDate: string | undefined, now: number): boolean {
  if (!closeDate) return false;
  // Keep the entire closing day available in Columbus, including across DST changes.
  const parts = COLUMBUS_DATE.formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((value) => value.type === type)?.value;
  const today = `${part("year")}-${part("month")}-${part("day")}`;
  return today > closeDate;
}
